import styled from 'styled-components';
import {Label} from '../../atoms/Label/index';
import NewItemForm from '../../molecules/NewItemForm/index';
import {UnderlinedList} from '../../atoms/ListItem/index';
import IconButton from '../../atoms/IconButton';
import HelpBox from '../../molecules/HelpBox';
import {BookIcon,QuestionIcon,InfoIcon} from '../../atoms/Icons';
import {Grey700, DividerColor, AccentColor,} from '../../Colors';

export default {
	RecipeListWrapper : styled.div`
        display: flex;
        flex-direction: column;
		overflow : hidden;
		height:100%;
		min-height:0;
		background-color : transparent;
		border-collapse : collapse;
	`,
	ShowRecipesHeader : styled.div`
		padding : 10px;
		border-bottom : 1px solid ${DividerColor};
		background-color : transparent;
		padding-bottom : 2rem;

		& > #label {
			display : flex;
			align-items : center;
		}
	`,
	ColumnFlexItemWrapper : styled.div`
		padding : 0 0.5rem;
		display: flex;
        flex-direction: column;
		overflow-y:auto;
	`,
	RecipeIcon : styled(BookIcon)`
		margin-right : 0.5rem;
		font-size : 2rem;
		color : ${Grey700};
	`,
	InfoIcon : styled(InfoIcon)`
		margin-right : 0.5rem;
		color : ${Grey700};
	`,
	IconButton,
	QuestionIcon : styled(QuestionIcon)`
		margin-left : 1rem;
		color : ${AccentColor};
	`,
	Label : styled(Label)`
		margin-bottom : 1rem;
		font-size : 2rem;
		color : ${Grey700};
    `,
	NewItemForm : styled(NewItemForm)`
		margin-top : 1rem;
		margin-bottom : 1rem;
	`,
	ListItem : styled(UnderlinedList)`
		margin-bottom : 1rem;
	`,
	HelpBox,
};